import React from "react";
import { Helmet } from "react-helmet";
import styles from "../style.module.scss";
import { PageBanner } from "../../../../components/parts/section";
import { productData } from "../../../../utils/constants";
import { CommonProductPage } from "../../../../components/parts";

const GalvanizedIronPipes = () => {
  const singleProductData = productData.filter((val) => val.id === 1);
  return (
    <>
      <Helmet>
        <title>
          Galvanized Steel Pipe | Galvanized Steel Tube Suppliers, Calgary
        </title>
        <meta
          name="description"
          content="At APF Steel, you can find Galvanized Steel Pipe Tubes. We offer the largest selection of Galvanized Pipes at wholesale prices."
        />
      </Helmet>
      <div className={styles.productInnerPage}>
        <PageBanner image={singleProductData[0].featured_image} />
        <CommonProductPage
          title={singleProductData[0].name}
          description={singleProductData[0].description}
          features={singleProductData[0].product_feature}
          gallery={singleProductData[0].productGallery}
        />
      </div>
    </>
  );
};

export default GalvanizedIronPipes;
